import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react-native';
import type { Theme } from '../../../src/theme/getTheme';

interface SettledIconProps {
  correct: boolean | null;
  theme: Theme;
}

export const SettledIcon: React.FC<SettledIconProps> = ({ correct, theme }) => {
  if (correct === true) return <CheckCircle size={14} color={theme.success} />;
  if (correct === false) return <XCircle size={14} color={theme.error} />;
  return null;
};
